"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface FaqItem {
  question: string;
  answerNode: React.ReactNode;
}
const faqs: FaqItem[] = [{
  question: "Do you provide roofing services across Southampton and nearby areas?",
  answerNode: <>
        Yes. As a dedicated roofer in Southampton, we cover the whole city and
        surrounding communities including Eastleigh, Chandler&apos;s Ford,
        Totton, Hedge End, Romsey, Fareham, Winchester, Hamble, and all nearby
        Hampshire towns. Whether you are in Shirley, Bitterne, Portswood, or
        Ocean Village, Matt and the team provide on-site assessments and clear,
        itemised quotes.
      </>
}, {
  question: "How long does a typical roof replacement take?",
  answerNode: <>
        Most residential roof replacements in Southampton are completed within 2
        to 5 working days, depending on property size, weather conditions, and
        the complexity of the roof design. Matt and the team keep your property
        watertight throughout the works.
      </>
}, {
  question: "What roofing services in Southampton do you specialise in?",
  answerNode: <>
        Our roofing services encompass pitched new roofs in slate and tile, flat
        roof installations using EPDM rubber or GRP fibreglass, chimney repairs
        and flaunching, brickwork repointing, moss removal and roof cleaning,
        complete replacement of uPVC fascias and soffits, guttering, and lead
        flashing and other lead work.
      </>
}, {
  question: "Can you help with urgent roof repairs in Southampton?",
  answerNode: <>
        Yes, sudden leaks and storm damage require prompt attention. If you need
        urgent roofing assistance in Southampton, you can contact Matt directly
        on{" "}
        <a href="tel:07443802652" className="font-semibold text-primary underline underline-offset-4 hover:text-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-sm">
          07443 802652
        </a>
        . We inspect the damage, make the property watertight, and carry out
        lasting structural repairs.
      </>
}, {
  question: "Which flat roofing systems do you install?",
  answerNode: <>
        We install modern EPDM rubber and GRP fibreglass flat roof systems across
        Southampton. Both options create seamless, durable surfaces ideal for
        kitchen extensions, dormers, garages, and bay window tops, replacing
        older brittle felt roofs.
      </>
}, {
  question: "Do you provide free quotes for roofing work?",
  answerNode: <>
        Yes, Matt conducts on-site inspections for homeowners across Southampton
        and surrounding Hampshire locations, followed by a transparent,
        itemised quote with no obligation.
      </>
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224143" id="common-questions" ref={ref} className="w-full py-16 sm:py-24 lg:py-[110px] bg-secondary text-foreground">
      <div className={`container mx-auto px-4 sm:px-6 max-w-3xl transition-all duration-1000 ease-out motion-reduce:transition-none motion-reduce:transform-none ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-widest text-primary mb-3">
            COMMON QUESTIONS
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-default font-bold mb-4 tracking-tight text-secondary-foreground">
            Frequently Asked Questions
          </h2>
          <p className="text-base sm:text-lg text-foreground/80 font-sans leading-relaxed">
            Find answers to common queries about our roofing services and roofline solutions in Southampton, Hampshire &amp; surrounding areas.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="bg-card border border-border rounded-[14px] px-5 sm:px-6 shadow-[0_4px_20px_-2px_rgba(21,25,29,0.06)] transition-all duration-200 hover:shadow-[0_8px_24px_-4px_rgba(21,25,29,0.1)] hover:border-primary/40 data-[state=open]:border-primary/60">
              <AccordionTrigger className="font-default font-bold text-left text-base sm:text-lg text-secondary-foreground hover:no-underline hover:text-primary transition-colors py-5 sm:py-6 min-h-[44px]">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-foreground/80 text-base leading-relaxed pb-6 font-sans">
                {faq.answerNode}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}